module.exports = __webpack_public_path__ + "static/img/m11.22ccbbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/mobile/m11.png
// module id = jGEw
// module chunks = 12